import { css } from "styled-components"
import { BoxWrapper } from "../../map/map-point.style"
import { SecondaryWrapper } from "../../bg-changer/bg-changer-wrapper.style"

const accentColor = " rgb(55, 254, 188)"

export const geburtstagStyles = css`
   * { font-family: "Geologica"; }

  .is-type-video, .wp-block-video {
    max-width: 640px;
    margin: 0 auto;
    box-shadow:rgb(54, 42, 72) 4px 4px 0px 0px;
    padding: 0 !important;

    video {
      width: 100%;
      display:block;
      margin:0;
    }
  }

  /*map-pointstyle__BoxWrapper-sc-trc3oa-2 hOcjXY wp-block-group */


  h1 {
  color: rgb(54, 42, 72);
  }

  h4 {
    color: rgb(54, 42, 72);
    button .toc-button-wrapper {display: none;}
    cursor: default;
    pointer-events: none;
  }

  p {
    font-weight: 200;
    font-size: 18px;
    line-height: 33px;
  }

  ${BoxWrapper} {
    padding-bottom: 0 !important;
    min-height: 0;

    h1 {
      color:white;
      text-shadow: 3px 2px rgb(54, 42, 72);
    }
  }

  ${SecondaryWrapper} {
    padding-bottom: 25vh;
    margin-top: -75vh;
    @media screen and (min-width: ${(p) => p.theme.breakpointMobile}) {
      margin-top: -65vh;
      padding-bottom: 90vh;
    }
  }

  .twingle-wrap {
    margin: 60px auto 0;
    padding-top:20px;
    border: 4px solid rgb(55, 254, 188);
    box-shadow:rgb(54, 42, 72) 4px 4px 0px 0px;
  }

  [class^="tv-overlay__"] {
    opacity: 0.1;
  }

  .wp-block-embed {
  pointer-events: auto;
    box-shadow:rgb(54, 42, 72) 4px 4px 0px 0px;
  }

  .reading-progress-bar {
    background: rgb(55, 254, 188) !important;
  }

  .wp-block-separator:after {
    background-color: rgb(55, 254, 188) !important;
  }

  .donation-encourager__wrapper, .nav-bar {
    display:none;
  }

`

